import { currentAuditEntryIdAtom } from '@/global-store';
import { useAtomValue } from 'jotai';
import { useFetchOrgUsers } from './useFetchOrgUsers';

export function useFetchDomainUsers() {
  const currentAuditEntryId = useAtomValue(currentAuditEntryIdAtom);

  return useFetchOrgUsers({ reportId: currentAuditEntryId });
}
